import Button from "@material-ui/core/Button";
import green from "@material-ui/core/colors/green";
import Dialog from "@material-ui/core/Dialog";
import { withStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import { TransverseLoading } from "react-loadingg";
import { toEnDigits } from "util/toEnDigits";
import { postAxios } from "../../api/Axios";
import { userApi } from "../../api/Urls";
import classes from "./AddUser.module.scss";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

const styles = (theme) => ({
  buttonProgress: {
    color: green[500],
  },
});

const AddUser = (props) => {
  const { t, i18n } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const handleRequestClose = () => {
    setOpen(false);
    setName("");
    setLastName("");
    setMobile("");
  };

  const clickHandler = async () => {
    setLoading(true);
    if (!name) {
      setLoading(false);
      return;
    } else if (!lastName) {
      setLoading(false);
      return;
    } else if (!mobile) {
      setLoading(false);
      return;
    }
    // else if (
    //   toEnDigits(mobile).length !== 11 ||
    //   !/09.*/.test(toEnDigits(mobile))
    // ) {
    // }

    let finalData = new FormData();
    finalData.append("first_name", name);
    finalData.append("last_name", lastName);
    finalData.append("phone", toEnDigits(mobile));
    postAxios(userApi, finalData)
      .then((data) => {
        props.newUserData(data.data.subscribers);
        setLoading(false);
        setOpen(false);
        setName("");
        setLastName("");
        setMobile("");
        enqueueSnackbar(data.data.message, {
          variant: "success",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
        });
      })
      .catch((err) => {
        if (err.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
          });
        }
        setLoading(false);
      });
  };

  /**
   * Convert just english digits to persian
   * @author Khalili
   * @param String $text
   * @returns String
   */
  const toPersianDigits = (text) => {
    var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return text.replace(/[0-9]/g, function (w) {
      return id[+w];
    });
  };

  return (
    <>
      <div className={classes.root}>
        <Button
          variant="contained"
          className="btn btn-primary jr-btn-uptin"
          onClick={() => setOpen(true)}
        >
          <span>{t("user.new_user")}</span>
        </Button>
        <Dialog
          open={open}
          onClose={handleRequestClose}
          className={classes.dialogRoot}
        >
          <div
            className="login-content text-center"
            style={{ maxWidth: "100%", borderRadius: "1.6rem" }}
          >
            <div className="mb-4">
              <h2>{t("user.new_user")}</h2>
            </div>

            <div className="login-form" style={{ borderRadius: "1.6rem" }}>
              <div className="form-group">
                <input
                  style={{ direction: i18n.dir() }}
                  type="text"
                  placeholder={t("user.name")}
                  className="form-control form-control-lg"
                  name="name"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                />
              </div>
              <div className="form-group">
                <input
                  style={{ direction: i18n.dir() }}
                  type="text"
                  placeholder={t("user.last_name")}
                  className="form-control form-control-lg"
                  name="lastName"
                  value={lastName}
                  onChange={(event) => setLastName(event.target.value)}
                />
              </div>
              <div className="form-group">
                <input
                  style={{ direction: i18n.dir() }}
                  placeholder={t("user.phone_number")}
                  className="form-control form-control-lg user-mobile-input"
                  name="mobile"
                  value={mobile}
                  onChange={(event) => {
                    setMobile(event.target.value);
                  }}
                />
              </div>
              <div className={`mt-4 mb-2 ${classes.modalPrimaryButton}`}>
                <Button
                  variant="contained"
                  disabled={loading}
                  onClick={clickHandler}
                >
                  {loading ? (
                    <>
                      {" "}
                      {t("user.add_user")}
                      <TransverseLoading />
                    </>
                  ) : (
                    t("user.add_user")
                  )}
                </Button>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default withStyles(styles)(AddUser);
